import React, { useState } from 'react';
import ModalDefault from '../../ModalDefault';
import ButtonDefault from '../../form/ButtonDefault';
import { IconClose } from '../../icons';
import { ModalWrapper, ModalTitle, ModalButtons } from '../../../pages/Demanda/styles';
import styled from 'styled-components';

const TextareaContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box;

    label {
        font-size: 14px;
        font-weight: 600;
        color: ${({ theme }) => theme.colors.interfaceText400};
    }

    textarea {
        width: 100% !important;
        max-width: 100% !important;
        min-height: 120px;
        padding: 12px;
        border: 1px solid ${({ theme }) => theme.colors.interfaceBorder100};
        border-radius: 6px;
        font-size: 14px;
        font-family: inherit;
        resize: vertical;
        transition: border-color 0.2s;
        box-sizing: border-box;

        &:focus {
            outline: none;
            border-color: ${({ theme }) => theme.colors.primaryRed400};
        }

        &::placeholder {
            color: ${({ theme }) => theme.colors.interfaceText200};
        }
    }

    .error {
        color: ${({ theme }) => theme.colors.primaryRed400};
        font-size: 12px;
        margin-top: 4px;
    }
`;

const ContentWrapper = styled.div`
    width: 100% !important;
    box-sizing: border-box;

    > * {
        width: 100% !important;
        max-width: 100% !important;
    }

    > div:not(:last-child) {
        width: 100% !important;
        max-width: 100% !important;
    }
`;

interface ModalCancelarDemandaProps {
    modalAtivo: boolean;
    setModalAtivo: (ativo: boolean) => void;
    onConfirmar: (justificativa: string) => Promise<void>;
    loading?: boolean;
}

export default function ModalCancelarDemanda({ 
    modalAtivo, 
    setModalAtivo, 
    onConfirmar,
    loading = false
}: ModalCancelarDemandaProps) {
    const [justificativa, setJustificativa] = useState('');
    const [erro, setErro] = useState('');

    const handleConfirmar = async () => {
        const justificativaTrimmed = justificativa.trim();
        
        if (!justificativaTrimmed) {
            setErro('O motivo do cancelamento é obrigatório');
            return;
        }

        setErro('');
        await onConfirmar(justificativaTrimmed);
    };

    const handleCancelar = () => {
        setJustificativa('');
        setErro('');
        setModalAtivo(false);
    };

    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setJustificativa(e.target.value);
        if (erro && e.target.value.trim()) {
            setErro('');
        }
    };

    return (
        <ModalDefault
            id={'overlayModal'}
            onClose={handleCancelar}
            openModal={modalAtivo}
            width="520px"
        >
            <ModalWrapper>
                <ModalTitle>
                    <div className="points">
                        Cancelar demanda
                    </div>
                    <div
                        className="close"
                        onClick={handleCancelar}
                    >
                        <IconClose />
                    </div>
                </ModalTitle>

                <ContentWrapper className="accept">
                    <p style={{ marginBottom: '16px', color: 'var(--c666666)' }}>
                        Esta ação não pode ser desfeita. Ao cancelar a demanda, o status será alterado para Cancelada.
                    </p>
                    <TextareaContainer style={{ width: '100%', maxWidth: '100%' }}>
                        <label>
                            Motivo do cancelamento <span style={{ color: 'var(--ce52940)' }}>*</span>
                        </label>
                        <textarea
                            placeholder="Escreva aqui o motivo do cancelamento"
                            value={justificativa}
                            onChange={handleChange}
                            disabled={loading}
                        />
                        {erro && <div className="error">{erro}</div>}
                    </TextareaContainer>
                </ContentWrapper>

                <ModalButtons>
                    <ButtonDefault
                        className="cancel"
                        onClick={handleCancelar}
                        disabled={loading}
                    >
                        Voltar
                    </ButtonDefault>
                    <ButtonDefault
                        className="danger"
                        onClick={handleConfirmar}
                        disabled={loading || !justificativa.trim()}
                    >
                        {loading ? 'Processando...' : 'Cancelar demanda'}
                    </ButtonDefault>
                </ModalButtons>
            </ModalWrapper>
        </ModalDefault>
    );
}

